import { FC, useContext } from 'react'
import { useDecodeAudioFile } from './hooks/useDecodeAudioFile'
import { AppContext } from '../AppContext'
import './UploadSelectButton.scss'
import { logger } from '../logger/logger'
import { LogActionType } from 'api/logs/log-action-type'
import { getLogAudioFileInfo } from '../functions/getLogAudioFileInfo'
import { getLogAudioBufferInfo } from '../functions/getLogAudioBufferInfo'
import { getPossibleErrorMessage } from '../functions/getPossibleErrorMessage'
import toast from 'react-hot-toast'

export const UploadSelectButton: FC = () => {
  const { setAudioBuffer, setUploadOpened, setFilename } = useContext(AppContext)
  const decodeAudioFile = useDecodeAudioFile()
  const onClick = () => {
    logger.log(LogActionType.UploadChooseFileButtonClick)

    const input = document.createElement('input')
    input.type = 'file'
    input.multiple = false
    input.onchange = async () => {
      const file = input.files?.item(0)

      if (file) {
        const toastId = toast.loading('Preparing the selected file')

        logger.log(LogActionType.UploadFileSelected, getLogAudioFileInfo(file))

        decodeAudioFile(file)
          .then((audioBuffer) => {
            logger.log(LogActionType.UploadFileDecoded, getLogAudioBufferInfo(audioBuffer))

            setFilename(file.name)
            setAudioBuffer(audioBuffer)
            setUploadOpened(false)
          })
          .catch((reason?: Error) => {
            logger.log(LogActionType.UploadDecodingError, getPossibleErrorMessage(reason))
          })
          .finally(() => {
            toast.dismiss(toastId)
          })
      }
    }

    input.click()
  }

  return (
    <button className="UploadSelectButton" onClick={onClick}>
      Choose file
    </button>
  )
}
